var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"colour-picker-option",class:{ 'selected-colour-picker': this.isSelected },style:({ background: ("" + _vm.colourPreviewHex) }),on:{"click":_vm.onSelectPalette}})}
var staticRenderFns = []

export { render, staticRenderFns }